import type { Node as ProsemirrorNode } from "prosemirror-model";

import React from "react";

import { IntegrationToken } from "@v2/features/chat/components/chat-elements/chat-tokens/IntegrationToken";
import { createRoot } from "react-dom/client";

/**
 * Custom NodeView for integration tokens.
 * NOTE (Kevin, 2025-12-18): Uses createRoot instead of ReactNodeViewRenderer
 * to fix an issue where tokens weren't rendered correctly by Tiptap's
 * contentComponent mechanism.
 */
export function IntegrationTokenNode({ node }: { node: ProsemirrorNode }) {
  const dom = document.createElement("span");
  dom.className = "integration-component";
  dom.contentEditable = "false";
  dom.style.display = "inline";

  const data = node.attrs.data;
  if (data && data.title) {
    const root = createRoot(dom);
    root.render(React.createElement(IntegrationToken, { data }));

    return {
      dom,
      destroy: () => {
        root.unmount();
      },
    };
  }

  return { dom };
}
